import type { CreateTarget } from "@/features/standalone-versions";
import { CardCloseButton, CardHeader, CardTitle } from "@components/ui/card";

export const CreateStoryHeader = ({
  close,
  createTarget = "story",
}: {
  close: () => void;
  createTarget?: CreateTarget;
}) => {
  return (
    <CardHeader className="tw-flex tw-items-center tw-justify-between">
      <CardTitle>
        {createTarget === "version" ? "New version" : "New story"}
      </CardTitle>
      <CardCloseButton onClick={close} />
    </CardHeader>
  );
};
